var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "holiday-rule-root",
      class: { "no-sort": !(_vm.prize1 && _vm.prize1.rank) },
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: _vm.$t("lang.commonM.k111"), "left-arrow": "" },
            on: { "click-left": _vm.goPrevious },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow02.png"),
                        alt: "",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c("div", { staticClass: "bg-block" }, [
        _c("div", { staticClass: "item-block" }, [
          _c("div", { staticClass: "item-tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k230"))),
          ]),
          _vm.actStartTime && _vm.actEndTime
            ? _c("div", { staticClass: "item-txt" }, [
                _vm._v(" 1. " + _vm._s(_vm.$t("lang.commonM.k231")) + ": "),
                _c("br"),
                _c("i", { staticStyle: { color: "#ff9524" } }, [
                  _vm._v(
                    _vm._s(_vm.actStartTime) + " - " + _vm._s(_vm.actEndTime)
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "item-txt" }, [
            _vm._v("2. " + _vm._s(_vm.$t("lang.commonM.k202"))),
          ]),
        ]),
        _c("div", { staticClass: "item-block" }, [
          _c("div", { staticClass: "item-tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k233"))),
          ]),
          _c("div", { staticClass: "item-txt" }, [
            _vm._v("1. " + _vm._s(_vm.$t("lang.commonM.k422"))),
          ]),
          _c("div", { staticClass: "item-tip-b" }, [
            _vm._v(
              _vm._s(_vm.$t("lang.commonM.k423")) +
                " 1 " +
                _vm._s(_vm.$t("lang.intimate.point")) +
                " "
            ),
            _c("i", [_vm._v(_vm._s(_vm.$t("lang.commonM.k424")))]),
          ]),
          _c("div", { staticClass: "item-tip-b" }, [
            _vm._v(
              _vm._s(_vm.$t("lang.commonM.k425")) +
                " 3 " +
                _vm._s(_vm.$t("lang.intimate.points")) +
                " "
            ),
            _c("i", [_vm._v(_vm._s(_vm.$t("lang.commonM.k424")))]),
          ]),
          _c("div", { staticClass: "item-txt" }, [
            _vm._v("2. " + _vm._s(_vm.$t("lang.commonM.k438"))),
          ]),
        ]),
        _c("div", { staticClass: "item-block" }, [
          _c("div", { staticClass: "item-tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k218"))),
          ]),
          _c("div", { staticClass: "item-txt" }, [
            _vm._v("1. " + _vm._s(_vm.$t("lang.commonM.k431"))),
          ]),
          _vm.actEndTime
            ? _c("div", { staticClass: "item-txt" }, [
                _vm._v(" 2. " + _vm._s(_vm.$t("lang.commonM.k432")) + " "),
                _c("br"),
                _c("i", { staticStyle: { color: "#ff9524" } }, [
                  _vm._v(_vm._s(_vm.actEndTime)),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "item-txt" }, [
            _vm._v("3. " + _vm._s(_vm.$t("lang.commonM.k433"))),
          ]),
        ]),
        _c("div", { staticClass: "item-block" }, [
          _c("div", { staticClass: "item-tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k201"))),
          ]),
          _c("div", { staticClass: "item-txt" }, [
            _vm._v("1. " + _vm._s(_vm.$t("lang.commonM.k434"))),
          ]),
          _c("div", { staticClass: "item-txt" }, [
            _vm._v("2. " + _vm._s(_vm.$t("lang.commonM.k204"))),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }